import { c as _c } from "react/compiler-runtime";
import EventsSkeleton from 'modules/main/components/event-box-section/events-skeleton';
import { EventBoxSectionProps } from 'modules/main/components/event-box-section/types';
import RenderEvent from 'modules/main/components/render-event';
import { useMain } from 'modules/main/hooks/use-main';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const EventBoxSection = React.forwardRef<HTMLDivElement, React.PropsWithChildren<EventBoxSectionProps>>(function EventBoxSection(t0, ref) {
  const $ = _c(16);
  const {
    filter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    events,
    revenue
  } = useMain(filter);
  const eventsData = events?.items;
  const hasEvents = eventsData?.length !== 0;
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.main.event.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-text-primary text-lg font-medium">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== eventsData || $[5] !== hasEvents || $[6] !== revenue) {
    t3 = eventsData ? hasEvents && <div className="flex flex-col gap-3 overflow-hidden"><ul className="flex flex-col gap-4">{eventsData.map((event, idx) => <React.Fragment key={idx}><li><RenderEvent event={event} /></li>{idx !== eventsData.length - 1 && <hr className="border-border-100" />}</React.Fragment>)}</ul></div> : <EventsSkeleton revenueLength={Object.keys(revenue || []).length} />;
    $[4] = eventsData;
    $[5] = hasEvents;
    $[6] = revenue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="desktop:absolute static flex w-full flex-col gap-5 px-6 py-5">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== hasEvents) {
    t5 = hasEvents && <div className="desktop:block absolute bottom-0 hidden h-[50px] w-[326px] rounded-lg bg-gradient-to-b from-transparent to-[var(--color-bg-primary)]" />;
    $[11] = hasEvents;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="border-border-100 bg-bg-primary desktop:w-[326px] relative min-h-[700px] w-full flex-none overflow-hidden rounded-lg border">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});